import React from 'react';
import TopBar from '../TopBar';
import BackOfficeSidebar from './BackOfficeSidebar';

const BackOfficeLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <TopBar />
      <div className="pt-16">
        <BackOfficeSidebar />
      </div>
      <main className="ml-64 min-h-screen pt-6">
        <div className="max-w-[1400px] mx-auto px-6 pb-10">
          {children}
        </div>
      </main>
    </div>
  );
};

export default BackOfficeLayout;
